interface Props {
  activeStep: number;
  totalSteps: number;
  onStepChange: (step: number) => void;
  className?: string;
  size?: "small" | "medium" | "large";
}

const DotNavigator = ({
  activeStep,
  totalSteps,
  onStepChange,
  className,
  size,
}: Props) => {
  const renderDot = (step: number) => {
    return (
      <button className="no-style-button" onClick={() => onStepChange(step)}>
        <div className={`dot ${step === activeStep ? "active" : ""}`} />
      </button>
    );
  };

  const getAllDots = () => {
    const dots = [];
    for (let i = 0; i < totalSteps; i++) {
      dots.push(renderDot(i));
    }
    return dots;
  };

  const getClassName = () => {
    let dotNavigatorClassName = "dot-navigator";
    if (className) {
      dotNavigatorClassName += ` ${className}`;
    }
    if (size) {
      dotNavigatorClassName += ` ${size}`;
    }
    return dotNavigatorClassName;
  };

  return <div className={getClassName()}> {getAllDots()}</div>;
};

export default DotNavigator;
